import React, { useState, useEffect } from 'react'
import './navbar.css'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { TbGridDots } from 'react-icons/tb'
import { AiFillCloseCircle } from 'react-icons/ai'
import { BsArrowRight } from 'react-icons/bs'
import image from '../../Assets/logo.png'
import LanguageSwitcher from './LanguageSwitcher'

const Navbar = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()
    const [active, setActive] = useState('navBar')
    const [isScrolled, setIsScrolled] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            // You can adjust this value as needed
            const scrollThreshold = 50
            setIsScrolled(window.scrollY > scrollThreshold)
        }

        // Add scroll event listener
        window.addEventListener('scroll', handleScroll)

        // Cleanup the event listener
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    const showNav = () => {
        setActive('navBar activeNavbar')
    }

    const removeNav = () => {
        setActive('navBar')
    }

    // Smooth scroll function — from another page, go home first
    const scrollToSection = (elementId) => {
        removeNav();

        if (location.pathname !== '/') {
            navigate('/', { state: { scrollTo: elementId } });
            return;
        }

        const element = document.getElementById(elementId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    return (
        <section className='navBarSection'>
            <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
                <div className="headerInner container flex">
                <div className='logoDiv'>
                    <div className="logo flex" onClick={() => scrollToSection('home')}>
                        <img src={image} alt="" />
                        <h1> Madeko </h1>
                    </div>
                </div>
                <div className={active}>
                    <ul className="navLists flex">
                        <li className="navItem">
                            <div
                                onClick={() => scrollToSection('home')}
                                className="navLink"
                            >
                                {t('nav.home')}
                            </div>
                        </li>
                        <li className="navItem">
                            <div
                                onClick={() => scrollToSection('about')}
                                className="navLink"
                            >
                                {t('nav.about')}
                            </div>
                        </li>
                        <li className="navItem">
                            <div
                                onClick={() => scrollToSection('activities')}
                                className="navLink"
                            >
                                {t('nav.news')}
                            </div>
                        </li>
                        <li className="navItem">
                            <div
                                onClick={() => scrollToSection('gallery')}
                                className="navLink"
                            >
                                {t('nav.gallery')}
                            </div>
                        </li>
                        <li className="navItem">
                            <div
                                onClick={() => scrollToSection('partners')}
                                className="navLink"
                            >
                                {t('nav.partners')}
                            </div>
                        </li>
                        <button
                            className="navCta"
                            onClick={() => scrollToSection('contact')}
                        >
                            {t('nav.contact')}
                            <span className="arrowCircle"><BsArrowRight/></span>
                        </button>
                    </ul>
                    <div onClick={removeNav} className="closeNavbar">
                        <AiFillCloseCircle className="icon"/>
                    </div>
                </div>
                <div className="headerActions">
                    <LanguageSwitcher/>
                    <div onClick={showNav} className="toggleNavbar">
                        <TbGridDots className="icon"/>
                    </div>
                </div>
                </div>
            </header>
        </section>
    )
}

export default Navbar